import { useEffect, useState } from "react";
import { AreaChart, Area } from "recharts";
import { MachinesByGroup } from "../../Types/dashboardTypes";
import { HistoricalTsiDataType } from "../../Types/portalTypes";

interface Props {
  color: string;
  machinesByGroup: MachinesByGroup[];
  currentMachineIndex: number;
  groupHistoricalData: HistoricalTsiDataType;
}
const AvgOeeAreaChart: React.FC<Props> = (props) => {
  const { color, machinesByGroup, currentMachineIndex, groupHistoricalData } = props;
  const [data, setData] = useState<{ date: string | null; oee: number | null }[] | [] | undefined>([
    { date: null, oee: null },
  ]);

  // const data = [
  //   {
  //     uv: 100,
  //   },
  //   {
  //     uv: 200,
  //   },
  //   {
  //     uv: 100,
  //   },
  //   {
  //     uv: 200,
  //   },
  //   {
  //     uv: 100,
  //   },
  //   {
  //     uv: 200,
  //   },
  //   {
  //     uv: 100,
  //   },
  // ];

  useEffect(() => {
    setData(groupHistoricalData[machinesByGroup[currentMachineIndex]?.machineSerial]);
  }, [machinesByGroup, currentMachineIndex, groupHistoricalData]);

  return (
    <AreaChart
      className="area-chart-avg-oee"
      width={250}
      height={60}
      data={data?.map((e) => ({ date: e.date, oee: e?.oee ?? 0 }))}
      margin={{
        top: 5,
        right: 0,
        left: 0,
        bottom: 5,
      }}
    >
      <defs>
        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor={color} stopOpacity={0.8} />
          <stop offset="95%" stopColor={color} stopOpacity={0} />
        </linearGradient>
      </defs>
      <Area
        type="linear"
        dataKey="oee"
        stroke="#8884d8"
        fillOpacity={1}
        fill="url(#colorUv)"
        isAnimationActive={false}
      />
    </AreaChart>
  );
};

export default AvgOeeAreaChart;
